/**=========================================================
 * Module: login.js
 * Login Controller
 =========================================================*/

App.controller('ResetController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', '$filter', '$http', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, $filter, $http, D) {
    "use strict";
    
    $scope.password = "";
    $scope.reset = $state.params.reset;
    $scope.id = $state.params.id;
    $scope.submitting = false;
    $scope.sent = false;
    $scope.submittable = false;
      

    $scope.checkPwdTimeouts = {};
	$scope.pwdStrength = { };
    var getLabel = function(lbl){
        return $filter('translate')('zxcvbn.'+lbl.replace(/\./g,'').replace(/,/g,'').replace(/'/g,'').replace(/-/g,'').replace(/"/g,'').replace(/ /g, '').toUpperCase())
    }
	$scope.checkPwd = function(fieldname){
        if($scope.checkPwdTimeouts[fieldname]){
            $timeout.cancel($scope.checkPwdTimeouts[fieldname]);
        }
        $scope.checkPwdTimeouts[fieldname] = $timeout(function(){
            $scope.checkingValue = $scope[fieldname]
            var checkingValue = $scope[fieldname]
            D.fn('zxcvbn', 'post', null, { pwd: $scope[fieldname] })
             .then(function(response){
                if(checkingValue!=$scope.checkingValue) return
                $scope.pwdStrength = {};
                var cls = '';
                if(response.score<=1) cls = 'alert-danger';
                if(response.score == 2) cls = 'alert-warning';
                var text = '';
                if(response.score > 2) {
                    cls = 'alert-success';
                    text = getLabel('PASSWORDISGOOD')
                    if(response.score==4) text = getLabel('PASSWORDISVERYGOOD');
                    $scope.submittable = true;
                } else {
                    $scope.submittable = false;
                }
                if(response.feedback.warning){
                    text += getLabel(response.feedback.warning) + '. ';
                } 
                if(response.feedback.suggestions){
                    if(typeof response.feedback.suggestions == 'string'){
                        text += getLabel(response.feedback.suggestions) + '.';
                    } else {
                        text += response.feedback.suggestions.map(function(l){ return getLabel(l);}).join('. ');
                    }
                }
                $timeout(function(){
                    $scope.pwdStrength = {
                        show: response.score <= 2,
                        cls: cls,
                        text: text.replace('..','.')
                    }
                }, 10);
            })
        }, 300);
    }

    $scope.newPwd = function(){
    
        if($scope.id && $scope.password && $scope.password==$scope.password2){
            $scope.submitting = true;
            R.one('action','ResetPassword').customPUT({ password: $scope.password, reset: $scope.reset, account: $scope.id }).then(
                function(){
                    $scope.submitting = false;
                    $scope.sent = true;
                }
            ).catch(function(e){
                $scope.submitting = false;
            })
        }
    }
  }
]);
